import {
  CodereChat,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  WhatsApp,
} from "../icons";
import { SPEEDSIZE_PREFIX } from "../App";
import { NavLink } from "react-router-dom";

function Footer() {
  const CODERE = "https://www.codere.com.co";
  const SUB_CODERE = "https://m.codere.com.co";

  const prefixUrl = `${SPEEDSIZE_PREFIX}${CODERE}/Colombia/images/footer/newPaymentLogos/cs-logo_`;
  const payments = [
    "PSE",
    "PuntoRed",
    "TPaga",
    "Visa",
    "Daviplata",
    "Dimonex",
    "Efecty",
    "Exito",
    "LocalCodere",
    "Mastercard",
    "Nequi",
    "payu",
  ];

  const sponsorsLogos = [
    "lifemiles",
    "codere-pastilla-rm",
    "casino-fantasia-royal",
    "crown",
    "mf",
  ];

  const linksDestacados = [
    {
      name: "Resultados y estadísticas",
      url: `${CODERE}/ayuda/resultados-y-estadisticas`,
    },
    {
      name: "Casino",
      url: "/casino",
      spa: true,
    },
    {
      name: "Casino en Vivo",
      url: "/casino/casino-en-vivo",
      spa: true,
    },
    {
      name: "Ruleta",
      url: "/casino/ruleta",
      spa: true,
    },
    {
      name: "Slots",
      url: "/casino/slots",
      spa: true,
    },
    {
      name: "Blackjack",
      url: "/casino/blackjack",
      spa: true,
    },
    {
      name: "Jackpots",
      url: "/casino/jackpots",
      spa: true,
    },
    {
      name: "Freebets",
      url: "/ayuda/free-bets",
      spa: true,
    },
    {
      name: "Descarga App",
      url: `${CODERE}/ayuda/apuesta-en-tu-movil`,
    },
    {
      name: "Blog Codere",
      url: "https://blog.codere.com.co/",
    },
  ];

  const legalLogos = [
    { name: "LogoColJuegos", url: "https://www.coljuegos.gov.co/" },
    { name: "logo-vigilado-supersalud" },
    { name: "logojuegobienco", url: "https://www.coljuegos.gov.co/" },
    {
      name: "logo-micro-sitio-coljuegos",
      url: "https://tomaelcontrol.coljuegos.gov.co/",
    },
  ];

  return (
    <footer className="nb-footer mt-5">
      <div className="d-flex justify-content-center mobiles">
        <a
          href="https://codere.onelink.me/ymBn/bec1421"
          rel="noreferrer"
          target="_blank"
        >
          <img
            height={45}
            width={"auto"}
            src={`${SPEEDSIZE_PREFIX}${CODERE}/_catalogs/masterpage/codere/img/FooterdescargaIos.png`}
            alt="Codere Colombia"
          />
        </a>
        <a
          href="https://codere.onelink.me/ymBn/bec1421"
          rel="noreferrer"
          target="_blank"
        >
          <img
            height={45}
            src={`${SPEEDSIZE_PREFIX}${CODERE}/Colombia/images/footer/android.png`}
            alt="Codere Colombia"
          />
        </a>
      </div>
      <div className="logos d-flex mt-4 gap-1 flex-wrap ">
        {sponsorsLogos.map((logo) => (
          <img
            key={logo}
            alt={`Logo-${logo}`}
            src={`${SPEEDSIZE_PREFIX}${CODERE}/assets/logos/logo-${logo}.webp`}
          />
        ))}
      </div>

      <div className="about">
        <div className="social-media">
          <ul className="list-inline">
            <li>
              <a
                href={`${SUB_CODERE}/deportesCol/#/mso/ContactPage`}
                title="Codere Colombia"
                rel="nofollow"
              >
                <CodereChat />
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/CodereColombia"
                title="Codere Colombia"
                rel="nofollow"
              >
                <Facebook />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/codereco/"
                title="Codere Colombia"
                rel="nofollow"
              >
                <Instagram />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/CodereCO"
                title="Codere Colombia"
                rel="nofollow"
              >
                <Twitter />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCT46v9eapBGC-3-vSHBlRvg"
                title="Codere Colombia"
                rel="nofollow"
              >
                <Youtube />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-3 col-6">
            <div className="footer-info-single">
              <span className="title">SOBRE NOSOTROS</span>
              <ul className="list-unstyled">
                <li>
                  <a
                    href={`${CODERE}/ayuda/juego-responsable`}
                    target="_blank"
                    rel="nofollow"
                  >
                    Juego Responsable
                  </a>
                </li>
                <li>
                  <a
                    href={`${CODERE}/ayuda/politica-de-cookies`}
                    rel="nofollow"
                  >
                    Política de cookies
                  </a>
                </li>
                <li>
                  <a
                    href={`${SUB_CODERE}/csbgonline/condicionesgenerales/ContratoColombia.pdf`}
                    target="_blank"
                    rel="nofollow"
                  >
                    Contrato
                  </a>
                </li>
                <li>
                  <a
                    href="http://condiciones.apuestas.codere.es/colombia/Condiciones_Colombia.html"
                    target="_blank"
                    rel="nofollow"
                  >
                    Reglas Apuestas
                  </a>
                </li>
                <li>
                  <a
                    href={`${CODERE}/ayuda/aviso-de-privacidad`}
                    target="_blank"
                    rel="nofollow"
                  >
                    Política de Privacidad
                  </a>
                </li>
                <li>
                  <a
                    href={`${SUB_CODERE}/csbgonline/condicionesgenerales/Acuerdo_08_2020.pdf`}
                    target="_blank"
                    rel="nofollow"
                  >
                    Reglamentos de los juegos de <br /> suerte y azar -
                    Coljuegos
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.codere-partners.com/"
                    target="_blank"
                    rel="nofollow"
                  >
                    Afiliados de Codere
                  </a>
                </li>
                <li>
                  <a
                    href={`${CODERE}/ayuda/estados-financieros`}
                    target="_blank"
                  >
                    Estados financieros
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-6">
            <div className="footer-info-single">
              <span className="title">LINKS DESTACADOS</span>
              <ul className="list-unstyled">
                {linksDestacados.map((li, i) => (
                  <li key={i}>
                    <NavLink
                      to={li.url}
                      href={!li.spa ? li.url : null}
                      rel={!li.spa ? "nofollow" : null}
                    >
                      {li.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="footer-info-single">
              <span className="title">DEPORTES</span>

              <ul className="list-unstyled">
                <li>
                  <a href={`${CODERE}/ayuda/deposito-online`}>
                    Info depósitos y cobros
                  </a>
                </li>
                <li>
                  <a href={`${CODERE}/ayuda/como-y-donde-apostar`}>
                    Cómo y dónde apostar
                  </a>
                </li>
                <li>
                  <a href={`${CODERE}/ayuda/como-obtener-freebets`}>
                    Cómo obtener freebets
                  </a>
                </li>
                <li>
                  <a
                    rel="nofollow"
                    href={`${SUB_CODERE}/deportesCol/#/mso/CuotaTypePage`}
                  >
                    Opciones de apuesta
                  </a>
                </li>
                <li>
                  <a href={`${CODERE}/eventos-deportivos`}>
                    Eventos deportivos
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-6">
            <div className="footer-info-single">
              <span className="title">AYUDA</span>

              <ul className="list-unstyled">
                <li>
                  <a href={`${CODERE}/ayuda`} rel="nofollow">
                    Área de ayuda
                  </a>
                </li>
                <li>
                  <a
                    href={`${CODERE}/ayuda/proteccion-datos-web`}
                    rel="nofollow"
                  >
                    Protección de Datos Web
                  </a>
                </li>
                <li>
                  <a
                    href={`${SUB_CODERE}/deportesCol/#/mso/ContactPage`}
                    target="_blank"
                  >
                    Área de contacto
                  </a>
                </li>
                <li>
                  <div className="d-flex align-items-center gap-2">
                    <WhatsApp />
                    <a
                      href="https://api.whatsapp.com/send?phone=573227565358"
                      rel="nofollow"
                      target="_blank"
                      className=""
                    >
                      +57 322 7565358
                    </a>
                  </div>
                </li>

                <li>
                  <a href="tel:018000975827" rel="nofollow" target="_blank">
                    Teléfono: 01-8000-975827
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:apuestas@codere.com"
                    rel="nofollow"
                    target="_blank"
                  >
                    Contacto: apuestas@codere.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <hr className="mb-4" />

      {/* payments here */}

      <div className="payments mb-3">
        {payments.map((payment, k) => (
          <img key={k} src={`${prefixUrl}${payment}.webp`}></img>
        ))}
      </div>

      <div className="juegas-banners">
        <div className="d-flex flex-wrap justify-content-center gap-3 align-items-center">
          {legalLogos.map((logo) => (
            <a
              rel="nofollow"
              target="_blank"
              key={logo.name}
              href={logo.url || null}
            >
              <img
                height={40}
                src={`${SPEEDSIZE_PREFIX}${CODERE}/assets/logos/${logo.name}.png`}
              />
            </a>
          ))}
        </div>
      </div>
      <div className="d-flex container px-md-5 px-3 flex-column m-auto mb-2">
        <div id="legals">
          <img
            alt="Mayores 18 años"
            className="more18"
            src={`${SPEEDSIZE_PREFIX}${CODERE}/_catalogs/masterpage/codere/img/18.png`}
            width="auto"
            height="auto"
          />
          <span className="legalFooter">
            <a
              rel="nofollow"
              href="https://www.jugadoresanonimoscolombia.org/"
              className="text-center text-decoration-none text-white footer-link"
              target="_blank"
              style={{ fontSize: "0.8rem" }}
            >
              Jugar sin control causa adicción. El juego es entretenimiento,
              Juega con moderación. Ser responsable es parte del juego.
              Prohibida la venta a menores de edad.
            </a>
          </span>
        </div>
        <div className="aenor-wrapper d-flex align-items-md-end align-items-center text-white">
          <div className="">
            <span
              className="legalFooter text-start"
              style={{ fontSize: "0.8rem" }}
            >
              Licenciataria <strong>Codere Online Colombia S.A.S.</strong> con
              domicilio principal en Bogotá, Colombia, Ak.103 No. 25F-12 y cuyo
              procesamiento de pagos son operados por Codere Apuestas S.A.U.
              Está licenciada en Colombia por COLJUEGOS con el número de
              concesión C1901 del 15 de noviembre de 2022 al 14 noviembre de
              2025. Operado por Codere Apuestas, S.A.U.
              <br />
              01-8000-975827 -{" "}
              <a href="mailto:apuestas@codere.com">apuestas@codere.com</a>
            </span>
          </div>
          <a
            href={`${SUB_CODERE}/csbgonline/condicionesgenerales/politicaseguridadinformacion.pdf`}
            rel="nofollow"
          >
            <img
              src={`${SPEEDSIZE_PREFIX}${CODERE}/Colombia/images/footer/logoaenoriso27001.png`}
              width="auto"
              height="auto"
              alt="AENOR Seguridad Información"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
